import type { Messages } from './types.ts';

export const ru = {
  'lang.uz': 'Oʻzbekcha',
  'lang.ru': 'Русский',
  'lang.en': 'English',

  'greeting.morning': 'Доброе утро, {name}',
  'greeting.day': 'Добрый день, {name}',
  'greeting.evening': 'Добрый вечер, {name}',
  'greeting.night': 'Доброй ночи, {name}',

  'home.title': 'Сказки',
  'home.profile': 'Профиль',
  'home.tonight': 'Сказка дня',
  'home.listen': 'Слушать',
  'home.continue': 'Продолжить',
  'home.minutesLeft': 'Осталось {count} мин',
  'home.all': 'Все сказки',
  'home.language': 'Язык сказок',

  'quota.free': '{count} бесплатно',
  'quota.freeLeft': 'Осталось бесплатно: {count}',
  'quota.none': 'Бесплатные закончились',
  'quota.premium': 'Премиум',

  'story.minutes': '{count} мин',
  'story.play': 'Слушать',
  'story.playing': 'Сейчас играет',
  'story.listened': 'Прослушано',
  'story.locked': 'Премиум',
  'story.draft': 'Черновик',

  'player.label': 'Плеер',
  'player.close': 'Свернуть',
  'player.more': 'Ещё',
  'player.tonight': 'Сказка дня',
  'player.story': 'Сказка',
  'player.withText': 'Слушать с текстом',
  'player.ended': 'Сказка закончилась',
  'player.meta': 'Сказка · {minutes} мин · {ageMin}–{ageMax} лет',
  'player.textCard': 'Текст сказки',
  'player.textCardHint': 'Открыть текст',
  'player.play': 'Слушать',
  'player.pause': 'Пауза',
  'player.back15': 'Назад на 15 секунд',
  'player.forward15': 'Вперёд на 15 секунд',
  'player.prev': 'Предыдущая сказка',
  'player.next': 'Следующая сказка',
  'player.seek': 'Время сказки',
  'player.buffering': 'Загружается…',
  'player.speed': 'Скорость',
  'player.timer': 'Таймер',
  'player.timerOff': 'Выкл',
  'player.timerEnd': 'До конца',
  'player.text': 'Текст',
  'player.textLoading': 'Загружаем текст…',
  'player.textError': 'Не удалось загрузить текст',
  'player.error': 'Звук не загрузился. Проверьте интернет.',
  'player.retrying': 'Связь прервалась — пробуем ещё раз…',

  'menu.share': 'Поделиться',
  'menu.shareText': 'Fonus Ertak — новая аудиосказка для детей каждый вечер 🌙',
  'menu.storyLang': 'Язык сказки',
  'menu.textSize': 'Размер текста',
  'menu.textSizeNormal': 'Обычный',
  'menu.textSizeLarge': 'Крупный',
  'menu.report': 'Сообщить о проблеме',
  'menu.cancel': 'Отмена',

  'sleep.title': 'Таймер сна',
  'sleep.hint': 'Когда время выйдет, сказка плавно затихнет и остановится',
  'sleep.off': 'Выкл',
  'sleep.minutes': '{count} минут',
  'sleep.end': 'До конца сказки',
  'sleep.done': 'Готово',

  'night.title': 'Ночной режим',
  'night.wake': 'Включить экран',
  'night.fade': 'Сказка тихо закончится · звук плавно стихнет',
  'night.plus5': '+5 минут',
  'night.stop': 'Остановить',

  'end.goodnight': 'Спокойной ночи, {name}!',
  'end.body': '«{title}» закончилась. Завтрашняя сказка придёт в {time}.',
  'end.next': 'Следующая сказка',
  'end.stopHere': 'Остановиться здесь',
  'end.pickOther': 'Выбрать другую сказку',

  'paywall.close': 'Закрыть',
  'paywall.badge': 'Премиум-сказка',
  'paywall.title': 'Новая сказка каждый вечер',
  'paywall.subStory': '«{title}» и все сказки откроются в Премиум.',
  'paywall.subGeneric': 'Все сказки откроются в Премиум.',
  'paywall.expiredTitle': 'Подписка закончилась',
  'paywall.expiredSubtitle': 'Продлите, чтобы слушать дальше',
  'paywall.valNightly': 'Новая сказка каждый вечер',
  'paywall.valArchive': 'Весь архив сказок',
  'paywall.valTextNight': 'Все сказки — с текстом и ночным режимом',
  'paywall.plans': 'Тариф',
  'paywall.save': 'Выгоднее на {percent}%',
  'plan.week': 'Неделя',
  'plan.month': 'Месяц',
  'plan.year': 'Год',
  'plan.perMonth': '{price} в месяц',
  'paywall.payClick': 'Оплатить через Click',
  'paywall.payPayme': 'Оплатить через Payme',
  'paywall.payStars': 'Оплатить Telegram Stars',
  'paywall.payFake': 'Тестовая оплата (dev)',
  'paywall.proof': '100 000+ семей уже с Fonus Kids',
  'paywall.noAutoCharge': 'Без автосписаний',
  'paywall.how': 'Как это работает',
  'paywall.stepToday': 'Сегодня',
  'paywall.stepTodayBody': 'Премиум откроется сразу',
  'paywall.stepTodayStory': 'Премиум откроется сразу — и «{title}» тоже',
  'paywall.stepNightly': 'Каждый вечер в {time}',
  'paywall.stepNightlyBody': 'Новая сказка и мягкое напоминание',
  'paywall.stepRemind': 'За 3 дня до конца',
  'paywall.stepRemindBody': 'Заранее напомним в Telegram',
  'paywall.restore': 'Восстановить покупку',
  'paywall.restoreNone': 'Активная подписка не найдена — напишите в поддержку',
  'paywall.offer': 'Оферта',
  'paywall.privacy': 'Конфиденциальность',

  'gate.title': 'Для взрослых',
  'gate.body': 'Чтобы продолжить оплату, выберите правильный ответ',
  'gate.wrong': 'Попробуйте ещё раз',
  'gate.cancel': 'Отмена',

  'payment.checking': 'Статус проверяется автоматически',
  'payment.waitingTitle': 'Подтверждаем оплату',
  'payment.waitingBody':
    'Подтвердите платёж в приложении {provider}. Премиум откроется сам, как только оплата пройдёт.',
  'payment.pendingBody': 'Оплата пока не подтверждена. Проверьте чуть позже.',
  'payment.stepCreated': 'Заказ создан',
  'payment.stepConfirm': 'Подтверждение в {provider}',
  'payment.stepUnlock': 'Премиум откроется',
  'payment.order': '{provider} · заказ № {orderNo}',
  'payment.planWeek': 'Подписка на неделю',
  'payment.planMonth': 'Подписка на месяц',
  'payment.planYear': 'Годовая подписка',
  'payment.open': 'Открыть {provider}',
  'payment.check': 'Проверить оплату',
  'payment.cancel': 'Отмена',
  'payment.help': 'Нужна помощь?',
  'payment.successChip': 'Премиум активен',
  'payment.successTitle': 'Сладких снов, {name}!',
  'payment.successBody': 'Теперь каждый вечер — новая сказка, и весь архив сказок ваш.',
  'payment.receipt': '{plan} · {price}',
  'payment.until': 'До {date} · чек в Telegram',
  'payment.remind': 'Напоминать в {time} каждый вечер',
  'payment.remindSub': 'Вместе сформируем привычку ко сну',
  'payment.listen': 'Слушать сказку',
  'payment.home': 'На главную',
  'payment.failedTitle': 'Оплата не прошла',
  'payment.failedBody': 'Не волнуйтесь — деньги не списаны.',
  'payment.why': 'Обычно причина',
  'payment.reasonFunds': 'Недостаточно средств на карте',
  'payment.reasonCancelled': 'Платёж отменён в {provider}',
  'payment.reasonNetwork': 'Пропало интернет-соединение',
  'payment.retry': 'Попробовать снова',
  'payment.support': 'Написать в поддержку',

  'profile.title': 'Профиль',
  'profile.close': 'Закрыть',
  'profile.premium': 'Премиум',
  'profile.active': 'Активен',
  'profile.planUntil': '{plan} · до {date}',
  'profile.planWeekly': 'На неделю',
  'profile.planMonthly': 'На месяц',
  'profile.planYearly': 'На год',
  'profile.manage': 'Управлять',
  'profile.noPremium': 'Нет Премиума',
  'profile.freeLeft': 'Бесплатных сказок осталось: {count}',
  'profile.ended': 'Закончился {date}',
  'profile.subscribe': 'Оформить',
  'profile.settings': 'Настройки',
  'profile.language': 'Язык',
  'profile.reminder': 'Вечернее напоминание',
  'profile.reminderAt': 'Каждый день в {time}',
  'profile.quality': 'Качество звука',
  'profile.qualityHint': 'Экономный режим тратит меньше мобильного трафика.',
  'profile.help': 'Помощь',
  'profile.support': 'Написать в поддержку',
  'profile.version': 'Fonus Ertak {version} · Fonus Kids',

  'quality.auto': 'Авто',
  'quality.low': 'Экономно',
  'quality.high': 'Высокое',

  'welcome.label': 'Добро пожаловать',
  'welcome.chip': '{count} {count:сказка|сказки|сказок} бесплатно',
  'welcome.title': 'Каждый день — новая аудиосказка',
  'welcome.body': 'Слушайте с ребёнком перед сном — на узбекском, русском и английском.',
  'welcome.start': 'Начать',

  'state.emptyTitle': 'На этом языке сказок пока нет',
  'state.emptyBody': 'Сказки на этом языке скоро появятся. А пока послушайте на узбекском.',
  'state.emptyCta': 'Перейти на узбекский',
  'state.emptyUzBody': 'Новые сказки скоро появятся.',
  'state.offlineTitle': 'Нет интернета',
  'state.offlineBody': 'Проверьте подключение — сказки вас подождут.',
  'state.retry': 'Повторить',
  'state.errorTitle': 'Что-то пошло не так',
  'state.errorBody': 'Не удалось загрузить сказки. Попробуйте чуть позже.',
  'state.reload': 'Обновить',
  'state.expiredTitle': 'Подписка закончилась',
  'state.expiredBody':
    'Премиум закончился {date}. Продлите — и новые сказки каждый вечер продолжатся.',
  'state.renew': 'Продлить подписку',
  'state.later': 'Позже',
  'state.reopenTitle': 'Откройте приложение заново',
  'state.reopenBody':
    'Приложение было открыто слишком долго. Закройте его и откройте снова через бота.',
  'state.reopenButton': 'Закрыть',

  'toast.langChanged': 'Язык изменён',
  'toast.slowNetwork': 'Медленный интернет — экономное качество',
  'toast.offline': 'Нет интернета — показываем сохранённые сказки',
  'toast.loading': 'Загружается',

  'bot.welcome':
    'Здравствуйте, {name}! 🌙\nКаждый вечер — новая сказка. Нажмите кнопку, чтобы слушать.',
  'bot.open': 'Открыть сказки',
  'bot.help':
    'Fonus Ertak — аудиосказки для детей.\n/start — открыть сказки\n/language — выбрать язык\n/subscription — статус подписки\n/help — помощь',
  /** Chat menu button (setChatMenuButton per chat, in the profile language). */
  'bot.menuButton': 'Сказки',
  'bot.cmdStart': 'Открыть сказки',
  'bot.cmdHelp': 'Помощь',
  'bot.cmdLanguage': 'Выбрать язык',
  'bot.cmdSubscription': 'Статус подписки',
  'bot.languagePick': 'Выберите язык:',
  'bot.languageSet': 'Язык изменён: Русский',
  'bot.subActive': 'Premium активен до {date}.\n{plan}',
  'bot.subNext': 'Следующий: {plan} с {date}',
  'bot.subGranted': 'Premium активен до {date}.',
  'bot.subNone': 'Premium нет. Бесплатных сказок осталось: {freeLeft}.',
  'bot.subEndedOn': 'Premium закончился {date}.',
  'bot.buy': 'Оформить Premium',
  'bot.renew': 'Продлить',
  'bot.tonight': 'Сказка на сегодня готова 🌙\n«{title}»',
  'bot.tonightNoTitle': 'Сказка на сегодня готова 🌙',
  'bot.listen': 'Слушать',
  'bot.subExpiring':
    'Premium закончится {date} — {days:остался|осталось|осталось} {days} {days:день|дня|дней}. Продлите, чтобы сказки не прерывались.',
  'bot.subEndsToday': 'Сегодня последний день Premium. Продлите, чтобы сказки не прерывались.',
  'bot.subEnded': 'Premium закончился сегодня. Продлите, чтобы слушать дальше.',
  'bot.receipt':
    'Оплата прошла ✅\nЗаказ № {orderNo}\n{plan} · {price}\nPremium активен до {date}.',
  'admin.storyReady': '🆕 Новая сказка готова к проверке: «{title}»\n{url}',
  'admin.ttsBudget':
    '⛔ Озвучка не запущена: не хватает кредитов ElevenLabs. Нужно ≈{need}, осталось {remaining}; за месяц {monthUsed} из {limit}.',
  'admin.ttsBudgetUnavailable':
    '⛔ Озвучка не запущена: не удалось проверить баланс ElevenLabs ({detail}).',
  'admin.contentFailed': '⚠️ Задача «{type}» упала: {error}',
  'admin.newPayment': '💳 Новая оплата № {orderNo}\n{plan} · {price} · {provider}',
  'admin.broadcastFailed': '⚠️ Вечерняя рассылка: {failed} ошибок ({sent} отправлено из {total}).',
  'admin.broadcastCrashed': '⚠️ Вечерняя рассылка остановилась: {error}',
  'admin.report':
    '📊 Отчёт за {date}\nНовых пользователей: {newUsers}\nСлушали: {listeners} · прослушиваний: {listens} (до конца: {completed})\nОплаты: {payments} · {revenue}\nАктивный Premium: {premium}\nРассылка: {broadcast}',
  'admin.reportNoBroadcast': 'не было',
  'admin.reportBroadcast': '{sent} отправлено · {blocked} заблокировали · {failed} ошибок',
} as const satisfies Messages;
